import { getRequest, patchRequest, postRequest } from "@/lib/api";

export type SupportCategory = "GENERAL" | "TRANSACTION" | "WELFARE";
export type TicketStatus = "OPEN" | "ACKNOWLEDGED" | "RESOLVED";
export type SupportTicket = {
  id: string;
  requesterId: string;
  orderId: string | null;
  category: SupportCategory;
  priority: "NORMAL" | "HIGH" | "EMERGENCY";
  subject: string;
  description: string;
  status: TicketStatus;
  firstResponseDueAt: string;
  resolutionDueAt: string;
  firstResponseBreached?: boolean;
  resolutionBreached?: boolean;
  adminNote: string | null;
  createdAt: string;
};
export const getSupportTickets = () =>
  getRequest<SupportTicket[]>("support-tickets");
export const createSupportTicket = (input: {
  category: SupportCategory;
  orderId?: string;
  subject: string;
  description: string;
}) => postRequest<SupportTicket, typeof input>("support-tickets", input);
export const getAdminSupportTickets = () =>
  getRequest<SupportTicket[]>("admin/support-tickets");
export const updateSupportTicket = (
  id: string,
  status: "ACKNOWLEDGED" | "RESOLVED",
  adminNote?: string,
) =>
  patchRequest<SupportTicket, { status: string; adminNote?: string }>(
    `admin/support-tickets/${id}`,
    { status, adminNote },
  );
